import React from "react";
import augmentWithAdverts from "./augmentWithAdverts";

const AdvertSwitch = Component => {
  let AugmentedWithAdverts;

  return ({ hasAdverts, ...passThroughProps }) => {
    if (hasAdverts) {
      if (!AugmentedWithAdverts) {
        AugmentedWithAdverts = augmentWithAdverts(Component);
      }

      return <AugmentedWithAdverts {...passThroughProps} />;
    } else {
      return <Component {...passThroughProps} />;
    }
  };
};

export default AdvertSwitch;
